import { base_url, makeRequestWithSilentLogin } from "../stores/GeneralStore";
import { get } from "svelte/store";
import { clientPath, createQueryFromFilter, selectedClientStore } from "./EnzianDataApi";
//Load the general client information
export async function getClient() {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId);
}
/**
 * Load a list of clients for this firm
 * @returns
 */
export async function getClients() {
    return makeRequestWithSilentLogin(base_url + "/" + clientPath);
}
/**
 * Create a new client
 * @param request
 * @returns
 */
export async function createClient(request) {
    return makeRequestWithSilentLogin(base_url + "/" + clientPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
/**
 * Delete an existing client.
 * @returns
 */
export async function deleteClient() {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId, {
        method: "DELETE",
    });
}
/**
 * Update an existing client.
 * @param request
 * @returns
 */
export async function patchClient(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
let printSettingsPath = "print-settings";
//Load the print settings with the given id
export async function getPrintSetting(printSettingId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + printSettingsPath + "/" + printSettingId);
}
//Create a new print template
export async function createPrintSetting(printTemplateType, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + printSettingsPath + "?templateType=" + printTemplateType, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
let printSettingCopyPath = "copy";
//Create a copy of an existing print setting.
export async function copyPrintSetting(printSettingId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + printSettingsPath + "/" + printSettingId + "/" + printSettingCopyPath, {
        method: "POST",
    });
}
//Delete an exisitng print setting.
export async function deletePrintSetting(printSettingId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + printSettingsPath + "/" + printSettingId, {
        method: "DELETE",
    });
}
//Update an existing print setting
export async function patchPrintSetting(printSettingId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + printSettingsPath + "/" + printSettingId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
let printSettingElementPath = "print-setting-elements";
//Update an existing print setting element
export async function patchPrintSettingElement(printSettingElementId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + printSettingElementPath + "/" + printSettingElementId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
let printSettingsTypePath = "type";
//Load the general client information
export async function getPrintSettingsForType(printSettingsTypeId, filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filter);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + printSettingsPath + "/" + printSettingsTypePath + "/" + printSettingsTypeId;
    return makeRequestWithSilentLogin(url + query);
}
let settingDocumentTypesPath = "setting-document-types";
//Load a single document type
export async function getSettingDocumentType(settingDocumentTypeId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentTypesPath + "/" + settingDocumentTypeId;
    return makeRequestWithSilentLogin(url);
}
//Load the document types
export async function getSettingDocumentTypes(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filter);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentTypesPath;
    return makeRequestWithSilentLogin(url + query);
}
//Create a new document type
export async function createSettingDocumentType(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentTypesPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an existing document type
export async function patchSettingDocumentType(settingDocumentTypeId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentTypesPath + "/" + settingDocumentTypeId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete a document type
export async function deleteSettingDocumentType(settingDocumentTypeId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentTypesPath + "/" + settingDocumentTypeId, {
        method: "DELETE"
    });
}
let settingDocumentNameGeneratorsPath = "setting-document-name-generators";
//Load the setting document name generators
export async function getSettingDocumentNameGenerators(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filter);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentNameGeneratorsPath;
    return makeRequestWithSilentLogin(url + query);
}
//Create a new setting document name generator
export async function createSettingDocumentNameGenerator(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentNameGeneratorsPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an existing setting document name generator
export async function patchSettingDocumentNameGenerator(settingDocumentNameGeneratorId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentNameGeneratorsPath + "/" + settingDocumentNameGeneratorId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete an existing setting document name generator
export async function deleteSettingDocumentNameGenerator(settingDocumentNameGeneratorId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentNameGeneratorsPath + "/" + settingDocumentNameGeneratorId, {
        method: "DELETE",
    });
}
let settingDocumentSettingsPath = "setting-document-settings";
//Load the default document settings for the given client
export async function getSettingDocumentSetting() {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentSettingsPath);
}
//Patch an existing setting document setting
export async function patchSettingDocumentSetting(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentSettingsPath, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
let settingPaymentPeriods = "setting-payment-periods";
//Load a single setting payment period
export async function getSettingPaymentPeriod(settingPaymentPeriodId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + settingPaymentPeriods + "/" + settingPaymentPeriodId;
    return makeRequestWithSilentLogin(url);
}
//Load a list of setting payment periods
export async function getSettingPaymentPeriods(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    let query = createQueryFromFilter(filter);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + settingPaymentPeriods;
    return makeRequestWithSilentLogin(url + query);
}
//Create a new setting payment period
export async function createSettingPaymentPeriod(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingPaymentPeriods, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an existing payment period
export async function patchSettingPaymentPeriod(settingPaymentPeriodId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingPaymentPeriods + "/" + settingPaymentPeriodId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete an existing payment period
export async function deleteSettingPaymentPeriod(settingPaymentPeriodId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingPaymentPeriods + "/" + settingPaymentPeriodId, {
        method: "DELETE",
    });
}
let settingPaymentPeriodValuesPath = "values";
//Create a new payment period value
export async function createSettingPaymentPeriodValue(settingPaymentPeriodId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingPaymentPeriods + "/" + settingPaymentPeriodId + "/" + settingPaymentPeriodValuesPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update an existing payment period value
export async function patchSettingPaymentPeriodValue(settingPaymentPeriodValueId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingPaymentPeriodValuesPath + "/" + settingPaymentPeriodValueId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete an existing payment period value
export async function deleteSettingPaymentPeriodValue(settingPaymentPeriodValueId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingPaymentPeriodValuesPath + "/" + settingPaymentPeriodValueId, {
        method: "DELETE",
    });
}
let settingDocumentConditionsPath = "setting-document-conditions";
//Load a list of setting document conditions
export async function getSettingDocumentConditions(filter) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    const query = createQueryFromFilter(filter);
    const url = base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentConditionsPath;
    return makeRequestWithSilentLogin(url + query);
}
//Create a new setting document conditions
export async function createSettingDocumentCondition(request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentConditionsPath, {
        method: "POST",
        body: JSON.stringify(request)
    });
}
//Update a setting document conditions
export async function patchSettingDocumentCondition(settingDocumentConditionId, request) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentConditionsPath + "/" + settingDocumentConditionId, {
        method: "PATCH",
        body: JSON.stringify(request)
    });
}
//Delete a setting document conditions
export async function deleteSettingDocumentCondition(settingDocumentConditionId) {
    const clientId = get(selectedClientStore)?.id;
    if (clientId == null)
        return Promise.reject();
    return makeRequestWithSilentLogin(base_url + "/" + clientPath + "/" + clientId + "/" + settingDocumentConditionsPath + "/" + settingDocumentConditionId, {
        method: "DELETE",
    });
}
